<template>
    <div class="layout">
        <!--
        <button class="btn-layout" @click.prevent="toggleLayout()">
            <svg x="0px" y="0px" width="35px" height="35px" viewBox="0 0 35 35" style="enable-background:new 0 0 35 35;" xml:space="preserve">
            <g>
                <g>
                    <path d="M0,0v35h35V0H0z M33,33H2V2h31V33z"/>
                    <rect x="7.5" y="7.5" width="20" height="20"/>
                </g>
            </g>
            </svg>
        </button>
        
        <template v-if="layout">
            <div class="container">
                <div class="btn-close"><icon-close></icon-close></div>
                <div class="deco"><div></div><div></div></div>
                <slot />
            </div>
        </template>
        <template v-else>
            -->
            <slot />
        <!-- </template> -->
    </div>
</template>

<script>
import IconClose from '@/components/IconClose'
export default {
    components: {
        IconClose,
    },
    data () {
        return {
            layout: false
        }
    },
    methods: {
        toggleLayout () {
            this.layout = !this.layout
        }
    }
}
</script>